'use client';

import { useRef, useState } from 'react';
import { useParams } from 'next/navigation';

import { Button } from '~/components/ui/button';
import { Input } from '~/components/ui/input';
import { LOFI_PASSWORD_PAGES } from '~/lib/config';

import { SectionHeader } from './section-header';

export function LowFiPasswordProtect(props: React.PropsWithChildren) {
  const { children } = props;

  const params = useParams();
  const [unlocked, setUnlocked] = useState(false);
  const [error, setError] = useState('');

  const lofiPassword = LOFI_PASSWORD_PAGES.find((page) => page.slug === params.slug?.[0])?.password;

  const passwordInputRef = useRef<HTMLInputElement>(null);

  const validatePassword: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();

    if (passwordInputRef?.current?.value === lofiPassword) {
      setUnlocked(true);
    } else {
      setError('Invalid Password, please try again.');
    }
  };

  if (lofiPassword && !unlocked) {
    return (
      <div className='px-5'>
        <div className='bg-neutral-2 mx-auto my-16 max-w-xl rounded-xl p-8 md:p-12'>
          <SectionHeader heading='Enter Your Password' icon='Rays' />
          <form className='flex flex-col gap-8' onSubmit={validatePassword}>
            <Input placeholder='Password' ref={passwordInputRef} />
            {error && <p className='text-red'>{error}</p>}
            <Button className='bg-blue' type='submit'>
              Submit
            </Button>
          </form>
        </div>
      </div>
    );
  }

  return children;
}
